/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Trades_DescriptionInputs */



/**
* | output |
* | --- |
* | "Requests, swaps to confirm, and who you're trading with" |
*
* @param {Nav_Trades_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_trades_description = /** @type {((inputs?: Nav_Trades_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Trades_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anfragen, offene Tausche und mit wem du tauschst")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demandes, échanges à confirmer et vos partenaires")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("交换请求、待确认的交换，以及你的交换对象")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("交易邀請、待確認的交換，以及與你交易的對象")
	if (locale === "ko") return /** @type {LocalizedString} */ ("요청, 확정 대기 중인 교환, 교환 상대")
	return /** @type {LocalizedString} */ ("Requests, swaps to confirm, and who you're trading with")
});